{
  "name": "nodeme",
  "version": "2.0.1",
  "author": "mxnode",
  "homepage": "https://mxnodeapp.co.za/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.6",
    "@angular/cdk": "^20.1.5",
    "@angular/common": "^20.1.6",
    "@angular/core": "^20.1.6",
    "@angular/forms": "^20.1.6",
    "@angular/material": "^20.1.5",
    "@angular/platform-browser": "^20.1.6",
    "@angular/platform-browser-dynamic": "^20.1.6",
    "@angular/router": "^20.1.6",
    "@auth0/angular-jwt": "^5.1.2",
    "@capacitor/app": "^7.0.0",
    "@capacitor/core": "^7.0.0",
    "@ionic/angular": "^8.2.0",
    "@ionic/core": "^8.2.0",
    "@ionic/storage-angular": "^4.0.0",
    "@microsoft/applicationinsights-web": "^3.2.2",
    "@zxcvbn-ts/core": "^3.0.0",
    "@zxcvbn-ts/language-common": "^2.0.1",
    "@zxcvbn-ts/language-en": "^3.0.0",
    "date-fns": "^4.0.0",
    "file-saver": "^2.0.5",
    "ngx-extended-pdf-viewer": "^24.3.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1",
    "zxcvbn3": "^0.1.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.1.5",
    "@angular-eslint/builder": "20.1.1",
    "@angular-eslint/eslint-plugin": "20.1.1",
    "@angular-eslint/eslint-plugin-template": "20.1.1",
    "@angular-eslint/schematics": "20.1.1",
    "@angular-eslint/template-parser": "20.1.1",
    "@angular/cli": "^20.1.5",
    "@angular/compiler": "^20.1.6",
    "@angular/compiler-cli": "^20.1.6",
    "@angular/language-service": "^20.1.6",
    "@capacitor/cli": "^7.0.0",
    "@ionic/angular-toolkit": "^12.0.0",
    "@types/google.maps": "^3.55.9",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^12.20.25",
    "@typescript-eslint/eslint-plugin": "7.10.0",
    "@typescript-eslint/parser": "7.10.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.2.5",
    "prettier-eslint": "^16.3.0",
    "typescript": "~5.8.3"
  }
}